exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#feedback-header{color:#ffc000;font-family:Calibri,Candara,Segoe,\"Segoe UI\",Optima,Arial,sans-serif;font-size:25px;font-weight:bold;margin-top:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/FeedbackForm/styles.scss
// module id = 780
// module chunks = 0